/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import UserActions from '@Actions/userActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import { Select, Popconfirm } from 'antd';
import { CountryCodes } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import SelectDepartment from '@Components/Common/SelectDepartment';
import MaskingPolicyActions from '@Actions/settings/maskingPolicyActions';
import Crown from '@Images/crown2.png';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const UserForm = ({
  user, selectedTenant, getRoles, roles, selectedUser, createUser, createUserLoading, callback, updateUser, updateUserLoading, getMaskingPolicies, maskingPolicies, locked,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [department, setDepartment] = useState('');
  const [role, setRole] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [phone, setPhone] = useState('');
  const [designation, setDesignation] = useState('');
  const [userId, setUserId] = useState('');
  const [maskingPolicy, setMaskingPolicy] = useState('');

  useEffect(() => {
    getRoles(selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id);
    getMaskingPolicies(user?.tenant_info?.org_id);
    if (selectedUser) {
      setMaskingPolicy(selectedUser?.data_masking_policy_id);
      setEmail(selectedUser?.username);
      setName(`${selectedUser?.first_name ? selectedUser?.first_name : ''} ${selectedUser?.last_name ? selectedUser?.last_name : ''}`);
      setCountryCode(String(selectedUser?.dial_code) || Helpers.getDialCode(user?.tenant_info?.country_code));
      setPhone(selectedUser?.mobile);
      setUserId(selectedUser?.user_id);
      setDepartment(selectedUser?.tenant_department_info?.department_id);
      setRole(selectedUser?.tenant_role_id);
      setDesignation(selectedUser?.designation);
    } else {
      setCountryCode(Helpers.getDialCode(user?.tenant_info?.country_code));
    }
  }, []);

  const addUser = () => {
    setFormSubmitted(true);
    if (selectedUser) {
      if (role && email && name) {
        const payload = {
          email,
          first_name: name,
          dial_code: countryCode,
          mobile: phone?.toString(),
          tenant_id: selectedTenant?.tenant_id || user?.tenant_info?.tenant_id,
          tenant_role_id: role,
          user_id: userId,
          designation,
          department,
          data_masking_policy_id: maskingPolicy || null,
        };
        updateUser([payload], () => callback());
      }
    } else if (role && Helpers.validateEmail(email.trim()) && Helpers.validatePhoneNumber(phone) && name) {
      const payload = {
        email,
        first_name: name,
        dial_code: countryCode,
        mobile: phone,
        is_active: true,
        data_masking_policy_id: maskingPolicy || null,
        tenant_user: [{
          tenant_id: selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id,
          tenant_role_id: role,
          designation,
        }],
      };
      createUser(payload, () => callback());
    }
  };

  const dataMasking = user?.tenant_info?.global_config?.sub_modules?.data_masking?.is_active;

  const countryOptions = CountryCodes?.map((item) => ({
    value: item?.dial_code,
    label: `${item?.flag} +${item?.dial_code}`,
  }));

  return (
    <div className="ant-row">
      <div className="ant-col-md-24 ant-col-xs-24">
        <SelectDepartment
          selectedDepartment={department}
          showSearch
          onChange={(value) => {
            setDepartment(value?.department_id);
            setRole('');
            getRoles(selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id, value?.tenant_department_id);
          }}
          tenantId={selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id}
          labelClassName="orgFormLabel"
          disabled={createUserLoading || updateUserLoading}
          emptyNotAllowed
        />
        {formSubmitted && !department && (
          <div className="input-error">
            *Please select department
          </div>
        )}
      </div>
      <div className="ant-col-md-24 ant-col-xs-24">
        <div className="orgInputContainer">
          <div style={{ display: 'flex' }}>
            <label style={{ width: '82%' }} className="orgFormLabel">
              Select Role
              <span style={{ color: 'red' }}>{'  *'}</span>
            </label>
          </div>
          <PRZSelect
            value={role}
            showSearch
            disabled={!department || createUserLoading || updateUserLoading}
            onChange={(selectedRole) => {
              setRole(selectedRole);
            }}
            showError={formSubmitted && !role}
            errorName=" role"
            errorClassName="input-error"
          >
            {roles?.data?.length && roles?.data?.map((item) => (
              <Option key={item.tenant_role_id} value={item.tenant_role_id}>
                {item.tenant_role_name}
              </Option>
            ))}
          </PRZSelect>

        </div>
      </div>
      <div className="ant-col-md-24 ant-col-xs-24">
        <H3FormInput
          name="Name"
          type="text"
          containerClassName="orgInputContainer"
          labelClassName="orgFormLabel"
          inputClassName="orgFormInput"
          placeholder=""
          onChange={(event) => setName(event.target.value)}
          value={name}
          label="Name"
          required
          showError={formSubmitted && !(name)}
          maxlength="50"
          disabled={selectedUser || createUserLoading || updateUserLoading}
        />
      </div>
      <div className="ant-col-md-24 ant-col-xs-24">
        <H3FormInput
          name="a valid email"
          type="text"
          containerClassName="orgInputContainer"
          labelClassName="orgFormLabel"
          inputClassName="orgFormInput"
          placeholder=""
          onChange={(event) => setEmail(event.target.value.trim())}
          value={email}
          required
          showError={formSubmitted && !Helpers.validateEmail(email.trim())}
          label="Email"
          disabled={selectedUser || createUserLoading || updateUserLoading}
        />
      </div>
      <div className="ant-col-md-24 ant-col-xs-24">
        <div style={{ marginBottom: '12px' }}>
          <H3Text
            text="Phone"
            className="orgFormLabel"
          />
          <div style={{ display: 'flex', alignItems: 'center', width: '270px' }}>
            <PRZSelect
              value={countryCode}
              showSearch
              filterOption={(input, option) => {
                const { label } = option.props;
                const { value } = option.props;
                return (
                  label.toLowerCase().includes(input.toLowerCase())
                  || value.toLowerCase().includes(input.toLowerCase())
                );
              }}
              onChange={(value) => setCountryCode(value)}
              className={formSubmitted && !countryCode ? 'prz-select__error-border' : ''}
              style={{
                width: '98px',
              }}
              disabled={createUserLoading || updateUserLoading || selectedUser}
              options={countryOptions}
            />
            <H3FormInput
              name="a valid phone number"
              type="text"
              containerClassName="user-form__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setPhone(event.target.value)}
              value={phone}
              disabled={createUserLoading || updateUserLoading || selectedUser}
              maxlength="50"
              showError={formSubmitted && phone && !Helpers.validatePhoneNumber(phone)}
            />
          </div>
        </div>
      </div>

      <div style={{ width: '100%' }} className='orgInputContainer'>
        <div className="orgFormLabel" style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            Policy Name
          </div>
          {!dataMasking && (<Popconfirm
            placement="topRight"
            title="This feature is not available in your current plan"
            onConfirm={() => window.Intercom('showNewMessage')}
            okText="Contact Us"
            cancelText="Cancel"
          >
            <img className="user-form-premium-img" src={Crown} alt="premium" />
          </Popconfirm>)}
        </div>
        <div>
          <PRZSelect
            value={maskingPolicy}
            showSearch
            onChange={(value) => setMaskingPolicy(value)}
            disabled={createUserLoading || updateUserLoading || !dataMasking}
            allowClear
            onClear={() => setMaskingPolicy(null)}
            placeholder=""
          >
            {maskingPolicies?.data?.map((mp) => (
              <Option
                key={mp?.data_masking_policy_id}
                value={mp?.data_masking_policy_id}
              >
                {`${mp?.data_masking_policy_name}`}
              </Option>
            ))}
          </PRZSelect>
        </div>
      </div>

      <div className="ant-col-md-24 ant-col-xs-24">
        <H3FormInput
          name="Designation"
          type="text"
          containerClassName="orgInputContainer"
          labelClassName="orgFormLabel"
          inputClassName="orgFormInput"
          placeholder=""
          onChange={(event) => setDesignation(event.target.value)}
          value={designation}
          label="Designation"
          disabled={createUserLoading || updateUserLoading}
        />
      </div>
      <div className="" style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem' }}>
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text={selectedUser ? 'Update User' : 'Add User'}
          onClick={() => addUser()}
          isLoading={createUserLoading || updateUserLoading}
          disabled={createUserLoading || updateUserLoading} // || (!selectedUser && !locked)
          style={{
            width: '120px',
            borderRadius: '5px',
            padding: '7px 0px',
            marginLeft: '0',
          }}
        />
        {/* {(!selectedUser && !locked) && (
          <Popconfirm
            placement="topRight"
            title={`Your can only add upto ${user?.tenant_info?.global_config?.settings?.user_limit} users within your current plan to add more users contact us.`}
            onConfirm={() => window.Intercom('showNewMessage')}
            okText="Contact Us"
            cancelText="Cancel"
          >
            <img
              className="barcode-restrict"
              src={Crown}
              alt="premium"
              style={{
                marginLeft: '8px',
                marginTop: '5px',
              }}
            />
          </Popconfirm>
        )} */}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, MaskingPolicyReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  roles: UserReducers.roles,
  createUserLoading: UserReducers.createUserLoading,
  updateUserLoading: UserReducers.updateUserLoading,
  maskingPolicies: MaskingPolicyReducers.maskingPolicies,
});
const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  getRoles: (tenantId, tenantDepartmentId) => dispatch(UserActions.getRoles(tenantId, tenantDepartmentId)),
  createUser: (payload, callback) => dispatch(UserActions.createUser(payload, callback)),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),
  getMaskingPolicies: (orgId, maskingPolicyId, page, limit, callback) => dispatch(MaskingPolicyActions.getMaskingPolicies(orgId, maskingPolicyId, page, limit, callback)),
});

UserForm.propTypes = {
  user: PropTypes.any,
  createUserLoading: PropTypes.bool,
  callback: PropTypes.any,
  roles: PropTypes.any,
  createUser: PropTypes.func,
  getRoles: PropTypes.func,
  selectedTenant: PropTypes.any,
  selectedUser: PropTypes.any,
  updateUser: PropTypes.func,
  updateUserLoading: PropTypes.bool,
  maskingPolicies: PropTypes.any,
  getMaskingPolicies: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserForm));
